import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'analytics',
  name: fr.title,
  description: fr.description,
  icon: 'chart',
  color: '#0F766E',
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: [
      'app.records.read',
      'app.records.write',
      'interactions.read',
      'tickets.read',
      'messages.read',
      'external.productions.read',
    ],
    defines: [],
  },
  entities: {
    uses: [{ entity: 'interactions' }, { entity: 'tickets' }, { entity: 'messages' }],
    owns: [
      { table: 'reports', scope: 'workspace', description: fr.reports },
      { table: 'exercises', scope: 'workspace', description: fr.exercises },
      { table: 'forecasts', scope: 'workspace', description: fr.forecastTitle },
      { table: 'commerce_reports', scope: 'workspace', description: fr.shop.reports },
      { table: 'ad_runs', scope: 'workspace', description: fr.ads.title },
    ],
  },
  events: {
    emits: emitsOf(events),
    subscribes: [
      { type: 'team.forecast.published', handler: 'onForecastPublished' },
      { type: 'ads.simulation.published', handler: 'onAdSimulation' },
    ],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: {
    actions: ['analytics.seed'],
    conditions: ['analytics.report_saved', 'analytics.shop_report_saved'],
    blocks: [],
  },
  migrations: { schema: 'app_analytics', dir: 'migrations' },
});
